export default "__VITE_ASSET__Br7yw1Fp__"